import { firebase } from '@firebase/app';
import '@firebase/firestore';
import '@firebase/auth';

var firebaseConfig = {
  apiKey: "AIzaSyDQuFnK8Mc1_u7gVagPaHgKc1LuVvdJUfE",
  authDomain: "memorizer-b515e.firebaseapp.com",
  databaseURL: "https://memorizer-b515e.firebaseio.com",
  projectId: "memorizer-b515e",
  storageBucket: "memorizer-b515e.appspot.com",
  messagingSenderId: "357707853636",
  appId: "1:357707853636:web:7818a5d21b6a7facbf3111"
};


export const app = firebase.initializeApp(firebaseConfig);


app.auth().onAuthStateChanged(function(user) {
  if (user) {
    sessionStorage.setItem('user', user.uid);
  }
});

export const db = app.firestore();
export const provider = new firebase.auth.GoogleAuthProvider();